import { Box, styled } from '@ltvco/refresh-lib/theme';

export const DetailsPageContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const DetailsContentSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(3),
  },
}));

export const DetailsTranscriptWrap = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
